import { render, staticRenderFns } from "./global-footer.vue?vue&type=template&id=6af91db6&scoped=true&"
import script from "./global-footer.vue?vue&type=script&lang=js&"
export * from "./global-footer.vue?vue&type=script&lang=js&"
import style0 from "./global-footer.vue?vue&type=style&index=0&id=6af91db6&prod&lang=less&"
import style1 from "./global-footer.vue?vue&type=style&index=1&id=6af91db6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af91db6",
  null
  
)

/* custom blocks */
import block0 from "./global-footer.vue?vue&type=custom&index=0&blockType=note"
if (typeof block0 === 'function') block0(component)

export default component.exports